export const SPANISH_NAV = [
    {
        id: "dashboard",
        label: "Tablero",
        path: "/",
    },
    {
        id: "inventory",
        label: "Inventario",
        path: "/inventory",
    },
    {
        id: "enhancedVisibility",
        label: "Visibilidad mejorada",
        path: "/enhanced",
    },
    {
        id: "emailNotifications",
        label: "Notificaciones de Correo Electrónico",
        path: "/email-notifications",
    },
    {
        id: "planning",
        label: "Planear",
        path: "/calendar-view",
        sub: [
            {
                id: "forecasting",
                label: "Previsión",
                path: "/calendar-view",
            },
            {
                id: "carOrders",
                label: "Pedido de Carro",
                path: "/car-order",
            },
            {
                id: "generalPlacement",
                label: "Colocación General",
                path: "/general-placement",
            },
            {
                id: "switchRequests",
                label: "Solicitudes de cambio",
                path: "/switch-requests",
            },
        ],
    },
    {
        id: "shipping",
        label: "Envío",
        path: "/shipping",
        sub: [
            {
                id: "ebol",
                label: "eBOL",
                path: "/ebol",
            },
        ],
    },
    {
        id: "chargeManagement",
        label: "Administracion de cargos",
        path: "/chargeManagement",
    },
]
